import classNames from "classnames";
import TabsContext from "hooks-contexts/TabsContext";
import {
  ReactNode,
  useContext,
  useState,
} from "react";
import styles from "./tabs-pill.module.scss";

export function Tabs({
  defaultValue,
  children,
}: {defaultValue: string; children: ReactNode}) {
  const [internalValue, setInternalValue] = useState(defaultValue);
  const activeTab = internalValue;

  const handleTabChange = (newValue: string) => {
    setInternalValue(newValue);
  };

  return (
    <TabsContext.Provider value={{ activeTab, setActiveTab: handleTabChange }}>
      {children}
    </TabsContext.Provider>
  );
}

// TabsList Component
export function TabsList({ children }: {children: ReactNode}) {
  return (
    <div className={classNames(styles.tabs_nav)} role="tablist">
      {children}
    </div>
  );
}

// TabsTrigger Component
interface TabsTriggerProps {
  value: string;
  children: ReactNode;
  icon?: ReactNode;
}

export function TabsTrigger({
  value,
  children,
  icon,
}: TabsTriggerProps) {
  const { activeTab, setActiveTab } = useContext(TabsContext);
  const isActive = activeTab === value;

  return (
    <button
      type="button"
      role="tab"
      aria-selected={isActive}
      className={classNames(styles.tab_button, {
        [styles.active]: isActive,
      })}
      onClick={() => setActiveTab(value)}
    >
      {icon}
      {children}
    </button>
  );
}

// TabsContent Component
interface TabsContentProps {
  value: string;
  children: ReactNode;
  className?: string;
}

export function TabsContent({ value, children, className }: TabsContentProps) {
  const { activeTab } = useContext(TabsContext);

  if (activeTab !== value) {
    return null;
  }

  return (
    <div className={classNames(styles.tab_content, className)} role="tabpanel">
      {children}
    </div>
  );
}
